/**
 * Message patterns Rollbar drops before reporting an occurrence.
 *
 * Rollbar compiles each entry with `new RegExp(entry, 'gi')` and tests it
 * against the occurrence's `trace.exception.message` and `message.body`
 * (see `messageIsIgnored` in rollbar.js). Entries therefore match anywhere in
 * the message and are always case-insensitive — anchor them if that matters.
 */
const rollbarIgnoredMessages: RegExp[] = [
  // Chunk fetch failures from a client still on the previous build after a
  // deploy has replaced the hashed bundles.
  /ChunkLoadError(.*)/i,

  // Browser-extension noise, not application code. An extension's injected
  // content script calls back into its own object registry after the entry is
  // gone; the error surfaces through our bundle's window.onerror with no file,
  // line, or stack frames. Observed as:
  //   "Object Not Found Matching Id:3, MethodName:update, ParamCount:4"
  //   "Object Not Found Matching Id:18, MethodName:simulateEvent, ParamCount:1"
  // Nothing in this repo emits these strings.
  /Object Not Found Matching Id:\d+,\s*MethodName:[^,]+,\s*ParamCount:\d+/,
]

export default rollbarIgnoredMessages
